// extracted by mini-css-extract-plugin
export var button = "Button-module__button___kiCxN";
export var primary = "Button-module__primary___emLIl Button-module__button___kiCxN";
export var secondary = "Button-module__secondary___Vw5XT Button-module__button___kiCxN";